import type { FaireProductEntity } from "../../entity_types/product";

export const p_xur25wvwqs: FaireProductEntity = {
  token: "p_xur25wvwqs",
  type: "product",
  name: "truth for today hope cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl: "https://cdn.faire.com/fastly/07d17ac7cb21e728bb36c41f03444dd0365eec63e121a72531c353d92b8859e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f2c5e5ee5876aca4c752865c99a207a7d1ee82c1b6a802b35cb3282e0a40d9a.jpeg",
    "https://cdn.faire.com/fastly/b1aea6d73a919324c78f0a095c812798766407d8ef873b7c38bd0cae2c730447.jpeg",
    "https://cdn.faire.com/fastly/27c0c1b6ec1067b5525a38bbd824db271aae915a33e286a3b6fe7cc90b4a0c75.jpeg",
    "https://cdn.faire.com/fastly/1527e20bd95e9c0cada41b06baba2867c1989ac9d1d8db6e424646fb2f96b909.jpeg",
    "https://cdn.faire.com/fastly/d4788aeca93ae99c523a5eed371b59bdc809c99ed039385c769681b8b111a17e.jpeg",
    "https://cdn.faire.com/fastly/c3cc2f010f8f62730590c064df60ef18eed923f471d138daad064145140538ef.jpeg",
    "https://cdn.faire.com/fastly/7b7d292a3b494fe04204c56760c80c093c8b2a72efe588638b8004dc7ea420db.jpeg",
    "https://cdn.faire.com/fastly/e19cd5f2395b2ca9c2c285a406f598cfc955a490d359d72d373061550b274036.jpeg",
    "https://cdn.faire.com/fastly/0baaa06e33b8b33057686e9910132333947d13bae251d65e8fd6e5b3662e92a3.jpeg",
    "https://cdn.faire.com/fastly/94e7fa32f986231c1f05027ad194bb2b97c6b5cfb37efb6447a0c15200493f88.jpeg",
    "https://cdn.faire.com/fastly/54a4c3f9d6a7b3b3c3d91646aed30ace281abfab86db12846aa9d3fa01cec5c8.jpeg"
  ],
  priceDollars: 17,
  description: "This set of Truth for Today cards is filled with the promise of HOPE. A set of scripture cards made especially for the one in need of gentle reminders of God's faithfulness and care. \n\nEach card pairs a Bible verse with a watercolor illustration. Display throughout your home for a pretty way to remember God's presence, tenderness, and trustworthiness. Use as daily or weekly truth to commit to memory, share them as encouragement with a friend, handpick a card to include in special notes, keep by your bedside to meditate on in the morning and night, or tie atop packages. They make a wonderful gift, especially for friends who need a little hope.\n",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:12.440Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
